module.exports = __webpack_public_path__ + "static/0007-4662c9ab5aa5bd0c6778a4e79748f2dc.png";